import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface StoreData {
  storeNo: string;
  storeCode: string;
  name: string;
  receiptBranchName: string;
}

@Injectable({
  providedIn: 'root'
})
export class StoreSyncService {
  private channel: BroadcastChannel | null = null;
  private storeChanged$ = new Subject<StoreData>();

  constructor() {
    this.initializeChannel();
  }

  private initializeChannel(): void {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel('store-sync-channel');

      this.channel.onmessage = (event) => {
        if (event.data.type === 'STORE_CHANGED') {
          this.storeChanged$.next(event.data.store);
          localStorage.setItem('CURRENT_STORE', JSON.stringify(event.data.store));
          window.location.reload();
        }
      };
    }
  }

  broadcastStoreChange(store: StoreData): void {
    if (this.channel) {
      this.channel.postMessage({
        type: 'STORE_CHANGED',
        store: store,
        timestamp: Date.now()
      });
    }
  }

  getStoreChanges() {
    return this.storeChanged$.asObservable();
  }

  destroy(): void {
    if (this.channel) {
      this.channel.close();
      this.channel = null;
    }
  }
}
